module.exports = __webpack_public_path__ + "img/weather_rainbow.84c2840f.png";